import { reactive, ref, watch } from "@vue/composition-api";
import { usePortalModel } from "@/composables/portal-model";
import { usePortalProfile } from "@/composables/portal-profile";
import { cloneDeep, isEmpty } from "lodash";

export function usePortalConfiguration() {
  const { portalModels } = usePortalModel();
  const { portalProfiles } = usePortalProfile();
  const portalProfile = ref(null);
  const portalConfigurationFormRef = ref(null);

  const hasFullPresentation = ref(false);
  const hasBasicPresentation = ref(false);

  const brandNewsletters = ref([
    { text: "    - Aucune", value: "" },
    { text: "ADG - Adagio", value: "ADG" },
    { text: "ART - Art Series", value: "ART" },
    { text: "BKF - BreakFree", value: "BKF" },
    { text: "EMB - Emblems", value: "EMB" },
    { text: "FRM - Fairmont", value: "FRM" },
    { text: "HEM - House of Emblems", value: "HEM" },
    { text: "HOF - Risalah HotelF1", value: "HOF" },
    { text: "IBP - Ibis Family", value: "IBP" },
    { text: "MEI - Grand Mercure", value: "MEI" },
    { text: "MER - Mercure", value: "MER" },
    { text: "MGA - MGallery", value: "MGA" },
    { text: "MOV - Mövenpick", value: "MOV" },
    { text: "MTA - Mantra", value: "MTA" },
    { text: "MTS - Mantis", value: "MTS" },
    { text: "NOV - Novotel", value: "NOV" },
    { text: "OEX - Orient Express", value: "OEX" },
    { text: "PEP - Peppers", value: "PEP" },
    { text: "PUL - Pullman", value: "PUL" },
    { text: "RFL - Raffles.com", value: "RFL" },
    { text: "RIX - Rixos", value: "RIX" },
    { text: "RSD - Branded residences", value: "RSD" },
    { text: "SOF - Sofitel", value: "SOF" },
    { text: "SWS - Swisshotels", value: "SWS" },
    { text: "THA - Thalassa", value: "THA" },
  ]);

  function initColor(portalConfigurationClone) {
    if (isEmpty(portalConfigurationClone.colors)) {
      portalConfigurationClone.colors = {
        primary: "#1976D2",
        secondary: "#424242",
        background: "#EAEAEA",
        opacity: 90,
      };
    }

    if (isEmpty(portalConfigurationClone.colors.primary)) {
      portalConfigurationClone.colors.primary = "#1976D2";
    }
    if (isEmpty(portalConfigurationClone.colors.secondary)) {
      portalConfigurationClone.colors.secondary = "#424242";
    }
    if (isEmpty(portalConfigurationClone.colors.background)) {
      portalConfigurationClone.colors.background = "#EAEAEA";
    }
    if (
      portalConfigurationClone.colors.opacity < 0 ||
      portalConfigurationClone.colors.opacity > 100 ||
      portalConfigurationClone.colors.opacity == null
    ) {
      portalConfigurationClone.colors.opacity = 90;
    }
  }

  function initConfigurationForm(props) {
    let portalConfigurationClone = cloneDeep(props.portalConfiguration);
    initColor(portalConfigurationClone);

    if (
      !isEmpty(portalConfigurationClone.basic_presentation) &&
      portalConfigurationClone.basic_presentation.access != null &&
      !isEmpty(portalConfigurationClone.basic_presentation.access)
    ) {
      hasBasicPresentation.value = true;
    } else {
      portalConfigurationClone.basic_presentation = {
        access: [],
      };
    }

    if (
      !isEmpty(portalConfigurationClone.full_presentation) &&
      portalConfigurationClone.full_presentation.access != null &&
      !isEmpty(portalConfigurationClone.full_presentation.access)
    ) {
      hasFullPresentation.value = true;
    } else {
      portalConfigurationClone.full_presentation = {
        access: [],
      };
    }

    if (isEmpty(portalConfigurationClone.ad)) {
      portalConfigurationClone.ad = {};
    }
    if (isEmpty(portalConfigurationClone.luxury)) {
      portalConfigurationClone.luxury = false;
    }
    if (isEmpty(portalConfigurationClone.brand_newsletter)) {
      portalConfigurationClone.brand_newsletter = "";
    }
    if (
      isEmpty(portalConfigurationClone.full_presentation) ||
      portalConfigurationClone.full_presentation.access == null
    ) {
      portalConfigurationClone.full_presentation = {
        access: [],
      };
    }
    if (isEmpty(portalConfigurationClone.languages)) {
      portalConfigurationClone.languages = [];
    }
    if (isEmpty(portalConfigurationClone.user_form)) {
      portalConfigurationClone.user_form = [];
    }

    const parentPortalConfiguration = reactive(portalConfigurationClone);
    if (props.portalConfigurationModel.custom != undefined) {
      if (isEmpty(parentPortalConfiguration.custom)) {
        parentPortalConfiguration.custom = {};
      }
      props.portalConfigurationModel.custom.forEach(
        (element) => (parentPortalConfiguration.custom[element] = "")
      );
    }

    watch(
      () => hasFullPresentation.value,
      function (newValue, oldValue) {
        if (newValue != oldValue) {
          if (newValue == false) {
            parentPortalConfiguration.full_presentation.access = null;
            parentPortalConfiguration.full_presentation.payment = null;
          }
        }
      }
    );

    watch(
      () => hasBasicPresentation.value,
      function (newValue, oldValue) {
        if (newValue != oldValue) {
          if (newValue == false) {
            parentPortalConfiguration.basic_presentation.access = null;
            parentPortalConfiguration.basic_presentation.payment = null;
          }
        }
      }
    );

    watch(
      () => parentPortalConfiguration.basic_presentation.payment,
      function (newValue, oldValue) {
        if (newValue != oldValue) {
          parentPortalConfiguration.basic_presentation.access = [];
        }
      }
    );

    watch(
      () => parentPortalConfiguration.full_presentation.payment,
      function (newValue, oldValue) {
        if (newValue != oldValue) {
          parentPortalConfiguration.full_presentation.access = [];
        }
      }
    );

    return parentPortalConfiguration;
  }

  return {
    initConfigurationForm,
    portalConfigurationFormRef,
    portalModels,
    portalProfile,
    portalProfiles,
    hasBasicPresentation,
    hasFullPresentation,
    initColor,
    brandNewsletters,
  };
}
